// // let countryToFlagCode =
// // {
// //   Afghanistan: "AF",
// //   Albania: "AL",
// //   Algeria: "DZ",
// //   Andorra: "AD",
// //   Angola: "AO",
// //   "Antigua and Barbuda": "AG",
// //   Argentina: "AR",
// //   Armenia: "AM",
// //   Australia: "AU",
// //   Austria: "AT",
// //   Azerbaijan: "AZ",
// //   Bahamas: "BS",
// //   Bahrain: "BH",
// //   Bangladesh: "BD",
// //   Barbados: "BB",
// //   Belarus: "BY",
// //   Belgium: "BE",
// //   Belize: "BZ",
// //   Benin: "BJ",
// //   Bhutan: "BT",
// //   Bolivia: "BO",
// //   "Bosnia and Herzegovina": "BA",
// //   Botswana: "BW",
// //   Brazil: "BR",
// //   Brunei: "BN",
// //   Bulgaria: "BG",
// //   "Burkina Faso": "BF",
// //   Burundi: "BI",
// //   "Cabo Verde": "CV",
// //   Cambodia: "KH",
// //   Cameroon: "CM",
// //   Canada: "CA",
// //   "Central African Republic": "CF",
// //   Chad: "TD",
// //   Chile: "CL",
// //   China: "CN",
// //   Colombia: "CO",
// //   Comoros: "KM",
// //   Congo: "CG",
// //   "Costa Rica": "CR",
// //   Croatia: "HR",
// //   Cuba: "CU",
// //   Cyprus: "CY",
// //   Czechia: "CZ",
// //   Denmark: "DK",
// //   Djibouti: "DJ",
// //   Dominica: "DM",
// //   "Dominican Republic": "DO",
// //   "East Timor": "TL",
// //   Ecuador: "EC",
// //   Egypt: "EG",
// //   "El Salvador": "SV",
// //   "Equatorial Guinea": "GQ",
// //   Eritrea: "ER",
// //   Estonia: "EE",
// //   Eswatini: "SZ",
// //   Ethiopia: "ET",
// //   Fiji: "FJ",
// //   Finland: "FI",
// //   France: "FR",
// //   Gabon: "GA",
// //   Gambia: "GM",
// //   Georgia: "GE",
// //   Germany: "DE",
// //   Ghana: "GH",
// //   Greece: "GR",
// //   Grenada: "GD",
// //   Guatemala: "GT",
// //   Guinea: "GN",
// //   "Guinea-Bissau": "GW",
// //   Guyana: "GY",
// //   Haiti: "HT",
// //   Honduras: "HN",
// //   Hungary: "HU",
// //   Iceland: "IS",
// //   India: "IN",
// //   Indonesia: "ID",
// //   Iran: "IR",
// //   Iraq: "IQ",
// //   Ireland: "IE",
// //   Israel: "IL",
// //   Italy: "IT",
// //   Jamaica: "JM",
// //   Japan: "JP",
// //   Jordan: "JO",
// //   Kazakhstan: "KZ",
// //   Kenya: "KE",
// //   Kiribati: "KI",
// //   "North Korea": "KP",
// //   "South Korea": "KR",
// //   Kosovo: "XK",
// //   Kuwait: "KW",
// //   Kyrgyzstan: "KG",
// //   Laos: "LA",
// //   Latvia: "LV",
// //   Lebanon: "LB",
// //   Lesotho: "LS",
// //   Liberia: "LR",
// //   Libya: "LY",
// //   Liechtenstein: "LI",
// //   Lithuania: "LT",
// //   Luxembourg: "LU",
// //   Madagascar: "MG",
// //   Malawi: "MW",
// //   Malaysia: "MY",
// //   Maldives: "MV",
// //   Mali: "ML",
// //   Malta: "MT",
// //   "Marshall Islands": "MH",
// //   Mauritania: "MR",
// //   Mauritius: "MU",
// //   Mexico: "MX",
// //   Micronesia: "FM",
// //   Moldova: "MD",
// //   Monaco: "MC",
// //   Mongolia: "MN",
// //   Montenegro: "ME",
// //   Morocco: "MA",
// //   Mozambique: "MZ",
// //   Myanmar: "MM",
// //   Namibia: "NA",
// //   Nauru: "NR",
// //   Nepal: "NP",
// //   Netherlands: "NL",
// //   "New Zealand": "NZ",
// //   Nicaragua: "NI",
// //   Niger: "NE",
// //   Nigeria: "NG",
// //   "North Macedonia": "MK",
// //   Norway: "NO",
// //   Oman: "OM",
// //   Pakistan: "PK",
// //   Palau: "PW",
// //   Panama: "PA",
// //   "Papua New Guinea": "PG",
// //   Paraguay: "PY",
// //   Peru: "PE",
// //   Philippines: "PH",
// //   Poland: "PL",
// //   Portugal: "PT",
// //   Qatar: "QA",
// //   Romania: "RO",
// //   Russia: "RU",
// //   "Russian Federation": "RU",
// //   Rwanda: "RW",
// //   "Saint Kitts and Nevis": "KN",
// //   "Saint Lucia": "LC",
// //   "Saint Vincent and the Grenadines": "VC",
// //   Samoa: "WS",
// //   "San Marino": "SM",
// //   "Sao Tome and Principe": "ST",
// //   "Saudi Arabia": "SA",
// //   Senegal: "SN",
// //   Serbia: "RS",
// //   Seychelles: "SC",
// //   "Sierra Leone": "SL",
// //   Singapore: "SG",
// //   Slovakia: "SK",
// //   Slovenia: "SI",
// //   "Solomon Islands": "SB",
// //   Somalia: "SO",
// //   "South Africa": "ZA",
// //   Spain: "ES",
// //   "Sri Lanka": "LK",
// //   Sudan: "SD",
// //   Suriname: "SR",
// //   Sweden: "SE",
// //   Switzerland: "CH",
// //   Syria: "SY",
// //   Taiwan: "TW",
// //   Tajikistan: "TJ",
// //   Tanzania: "TZ",
// //   Thailand: "TH",
// //   Togo: "TG",
// //   Tonga: "TO",
// //   "Trinidad and Tobago": "TT",
// //   Tunisia: "TN",
// //   Turkey: "TR",
// //   Turkmenistan: "TM",
// //   Tuvalu: "TV",
// //   Uganda: "UG",
// //   Ukraine: "UA",
// //   UAE: "AE",
// //   "United Arab Emirates": "AE",
// //   "United Kingdom": "GB",
// //   UK: "GB",
// //   USA: "US",
// //   "United States": "US",
// //   "United States of America": "US",
// //   Uruguay: "UY",
// //   Uzbekistan: "UZ",
// //   Vanuatu: "VU",
// //   "Vatican City": "VA",
// //   Venezuela: "VE",
// //   Vietnam: "VN",
// //   Yemen: "YE",
// //   Zambia: "ZM",
// //   Zimbabwe: "ZW",
// // };
// const countryToFlagCode = {
//   Afghanistan: "AF",
//   Albania: "AL",
//   Algeria: "DZ",
//   Andorra: "AD",
//   Angola: "AO",
//   Anguilla: "AI",
//   Antarctica: "AQ",
//   "Antigua and Barbuda": "AG",
//   Argentina: "AR",
//   Armenia: "AM",
//   Aruba: "AW",
//   Australia: "AU",
//   Austria: "AT",
//   Azerbaijan: "AZ",
//   Bahamas: "BS",
//   Bahrain: "BH",
//   Bangladesh: "BD",
//   Barbados: "BB",
//   Belarus: "BY",
//   Belgium: "BE",
//   Belize: "BZ",
//   Benin: "BJ",
//   Bermuda: "BM",
//   Bhutan: "BT",
//   Bolivia: "BO",
//   "Bosnia and Herzegovina": "BA",
//   Botswana: "BW",
//   Brazil: "BR",
//   "British Indian Ocean Territory": "IO",
//   Brunei: "BN",
//   Bulgaria: "BG",
//   "Burkina Faso": "BF",
//   Burundi: "BI",
//   "Cabo Verde": "CV",
//   Cambodia: "KH",
//   Cameroon: "CM",
//   Canada: "CA",
//   "Cayman Islands": "KY",
//   "Central African Republic": "CF",
//   Chad: "TD",
//   Chile: "CL",
//   China: "CN",
//   "Christmas Island": "CX",
//   "Cocos (Keeling) Islands": "CC",
//   Colombia: "CO",
//   Comoros: "KM",
//   "Cook Islands": "CK",
//   "Costa Rica": "CR",
//   Croatia: "HR",
//   Cuba: "CU",
//   Curaçao: "CW",
//   Cyprus: "CY",
//   Czechia: "CZ",
//   "Czech Republic": "CZ",
//   "Democratic Republic of the Congo": "CD",
//   Denmark: "DK",
//   Djibouti: "DJ",
//   Dominica: "DM",
//   "Dominican Republic": "DO",
//   "East Timor": "TL",
//   Ecuador: "EC",
//   Egypt: "EG",
//   "El Salvador": "SV",
//   "Equatorial Guinea": "GQ",
//   Eritrea: "ER",
//   Estonia: "EE",
//   Eswatini: "SZ",
//   Ethiopia: "ET",
//   "Falkland Islands": "FK",
//   Fiji: "FJ",
//   Finland: "FI",
//   France: "FR",
//   "French Guiana": "GF",
//   "French Polynesia": "PF",
//   Gabon: "GA",
//   Gambia: "GM",
//   Georgia: "GE",
//   Germany: "DE",
//   Ghana: "GH",
//   Gibraltar: "GI",
//   Greece: "GR",
//   Greenland: "GL",
//   Grenada: "GD",
//   Guadeloupe: "GP",
//   Guinea: "GN",
//   "Guinea-Bissau": "GW",
//   Guyana: "GY",
//   Haiti: "HT",
//   Honduras: "HN",
//   "Hong Kong": "HK",
//   Hungary: "HU",
//   Iceland: "IS",
//   India: "IN",
//   Indonesia: "ID",
//   Iran: "IR",
//   Iraq: "IQ",
//   Ireland: "IE",
//   Israel: "IL",
//   Italy: "IT",
//   Jamaica: "JM",
//   Japan: "JP",
//   Jersey: "JE",
//   Jordan: "JO",
//   Kazakhstan: "KZ",
//   Kenya: "KE",
//   Kiribati: "KI",
//   "North Korea": "KP",
//   "South Korea": "KR",
//   Kosovo: "XK",
//   Kuwait: "KW",
//   Kyrgyzstan: "KG",
//   Laos: "LA",
//   Latvia: "LV",
//   Lebanon: "LB",
//   Lesotho: "LS",
//   Liberia: "LR",
//   Libya: "LY",
//   Liechtenstein: "LI",
//   Lithuania: "LT",
//   Luxembourg: "LU",
//   Macau: "MO",
//   Madagascar: "MG",
//   Malawi: "MW",
//   Malaysia: "MY",
//   Maldives: "MV",
//   Mali: "ML",
//   Malta: "MT",
//   "Marshall Islands": "MH",
//   Martinique: "MQ",
//   Mauritania: "MR",
//   Mauritius: "MU",
//   Mayotte: "YT",
//   Mexico: "MX",
//   Micronesia: "FM",
//   Moldova: "MD",
//   Monaco: "MC",
//   Mongolia: "MN",
//   Montenegro: "ME",
//   Morocco: "MA",
//   Mozambique: "MZ",
//   Myanmar: "MM",
//   Namibia: "NA",
//   Nauru: "NR",
//   Nepal: "NP",
//   Netherlands: "NL",
//   "New Zealand": "NZ",
//   Nicaragua: "NI",
//   Niger: "NE",
//   Nigeria: "NG",
//   "North Macedonia": "MK",
//   Norway: "NO",
//   Oman: "OM",
//   Pakistan: "PK",
//   Palau: "PW",
//   Panama: "PA",
//   "Papua New Guinea": "PG",
//   Paraguay: "PY",
//   Peru: "PE",
//   Philippines: "PH",
//   "Pitcairn Islands": "PN",
//   Poland: "PL",
//   Portugal: "PT",
//   "Puerto Rico": "PR",

//   // United States
//   USA: "US",
//   "United States": "US",
//   "United States of America": "US",

//   Qatar: "QA",
//   Romania: "RO",
//   Russia: "RU",
//   "Russian Federation": "RU",
//   Rwanda: "RW",
//   "Saint Kitts and Nevis": "KN",
//   "Saint Lucia": "LC",
//   "Saint Vincent and the Grenadines": "VC",
//   Samoa: "WS",
//   "San Marino": "SM",
//   "São Tomé and Príncipe": "ST",
//   "Saudi Arabia": "SA",
//   Senegal: "SN",
//   Serbia: "RS",
//   Seychelles: "SC",
//   "Sierra Leone": "SL",
//   Singapore: "SG",
//   Slovakia: "SK",
//   Slovenia: "SI",
//   "Solomon Islands": "SB",
//   Somalia: "SO",
//   "South Africa": "ZA",

//   // United Kingdom
//   UK: "GB",
//   "United Kingdom": "GB",
//   Britain: "GB",

//   Spain: "ES",
//   "Sri Lanka": "LK",
//   Sudan: "SD",
//   Suriname: "SR",
//   Sweden: "SE",
//   Switzerland: "CH",
//   Syria: "SY",
//   Taiwan: "TW",
//   Tajikistan: "TJ",
//   Tanzania: "TZ",
//   Thailand: "TH",
//   Togo: "TG",
//   Tokelau: "TK",
//   Tonga: "TO",
//   "Trinidad and Tobago": "TT",
//   Tunisia: "TN",
//   Turkey: "TR",
//   Turkmenistan: "TM",
//   Tuvalu: "TV",
//   Uganda: "UG",
//   Ukraine: "UA",
//   UAE: "AE",
//   Uruguay: "UY",
//   Uzbekistan: "UZ",
//   Vanuatu: "VU",
//   "Vatican City": "VA",
//   Venezuela: "VE",
//   Vietnam: "VN",
//   "Wallis and Futuna": "WF",
//   "Western Sahara": "EH",
//   Yemen: "YE",
//   Zambia: "ZM",
//   Zimbabwe: "ZW",
// };

// // export default countryToFlagCode;

// export default countryToFlagCode;

const countryToFlagCode = {
  Afghanistan: "AF",
  Albania: "AL",
  Algeria: "DZ",
  Andorra: "AD",
  Angola: "AO",
  Anguilla: "AI",
  Antarctica: "AQ",
  "Antigua and Barbuda": "AG",
  Argentina: "AR",
  Armenia: "AM",
  Aruba: "AW",
  Australia: "AU",
  Austria: "AT",
  Azerbaijan: "AZ",
  Bahamas: "BS",
  Bahrain: "BH",
  Bangladesh: "BD",
  Barbados: "BB",
  Belarus: "BY",
  Belgium: "BE",
  Belize: "BZ",
  Benin: "BJ",
  Bermuda: "BM",
  Bhutan: "BT",
  Bolivia: "BO",
  "Bosnia and Herzegovina": "BA",
  Botswana: "BW",
  "Bouvet Island": "BV",
  Brazil: "BR",
  "British Indian Ocean Territory": "IO",
  Brunei: "BN",
  Bulgaria: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  "Cabo Verde": "CV",
  Cambodia: "KH",
  Cameroon: "CM",
  Canada: "CA",
  "Cayman Islands": "KY",
  "Central African Republic": "CF",
  Chad: "TD",
  Chile: "CL",
  China: "CN",
  "Christmas Island": "CX",
  "Cocos (Keeling) Islands": "CC",
  Colombia: "CO",
  Comoros: "KM",
  "Cook Islands": "CK",
  "Costa Rica": "CR",
  Croatia: "HR",
  Cuba: "CU",
  Curaçao: "CW",
  Cyprus: "CY",
  Czechia: "CZ",
  "Czech Republic": "CZ",
  Denmark: "DK",
  Djibouti: "DJ",
  Dominica: "DM",
  "Dominican Republic": "DO",
  "East Timor": "TL",
  Ecuador: "EC",
  Egypt: "EG",
  "El Salvador": "SV",
  "Equatorial Guinea": "GQ",
  Eritrea: "ER",
  Estonia: "EE",
  Eswatini: "SZ",
  Ethiopia: "ET",
  "Falkland Islands": "FK",
  Fiji: "FJ",
  Finland: "FI",
  France: "FR",
  "French Guiana": "GF",
  "French Polynesia": "PF",
  Gabon: "GA",
  Gambia: "GM",
  Georgia: "GE",
  Germany: "DE",
  Ghana: "GH",
  Gibraltar: "GI",
  Greenland: "GL",
  Grenada: "GD",
  Guadeloupe: "GP",
  Guinea: "GN",
  "Guinea-Bissau": "GW",
  Guyana: "GY",
  Haiti: "HT",
  Honduras: "HN",
  "Hong Kong": "HK",
  Hungary: "HU",
  Iceland: "IS",
  India: "IN",
  Indonesia: "ID",
  Iran: "IR",
  Iraq: "IQ",
  Ireland: "IE",
  Israel: "IL",
  Italy: "IT",
  Jamaica: "JM",
  Japan: "JP",
  Jersey: "JE",
  Jordan: "JO",
  Kazakhstan: "KZ",
  Kenya: "KE",
  Kiribati: "KI",
  "North Korea": "KP",
  "South Korea": "KR",
  Kosovo: "XK",
  Kuwait: "KW",
  Kyrgyzstan: "KG",
  Laos: "LA",
  Latvia: "LV",
  Lebanon: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  Libya: "LY",
  Liechtenstein: "LI",
  Lithuania: "LT",
  Luxembourg: "LU",
  Macau: "MO",
  Madagascar: "MG",
  Malawi: "MW",
  Malaysia: "MY",
  Maldives: "MV",
  Mali: "ML",
  Malta: "MT",
  "Marshall Islands": "MH",
  Martinique: "MQ",
  Mauritania: "MR",
  Mauritius: "MU",
  Mayotte: "YT",
  Mexico: "MX",
  Micronesia: "FM",
  Moldova: "MD",
  Monaco: "MC",
  Mongolia: "MN",
  Montenegro: "ME",
  Morocco: "MA",
  Mozambique: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  Netherlands: "NL",
  "New Zealand": "NZ",
  Nicaragua: "NI",
  Niger: "NE",
  Nigeria: "NG",
  "North Macedonia": "MK",
  Norway: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  Panama: "PA",
  "Papua New Guinea": "PG",
  Paraguay: "PY",
  Peru: "PE",
  Philippines: "PH",
  "Pitcairn Islands": "PN",
  Poland: "PL",
  Portugal: "PT",
  "Puerto Rico": "PR",

  // United States variants
  USA: "US",
  "United States": "US",
  "United States of America": "US",
  "United Arab Emirates": "AE",
  "United Kingdom": "GB",
  Qatar: "QA",
  Romania: "RO",
  Russia: "RU",
  "Russian Federation": "RU",
  Rwanda: "RW",
  "Saint Kitts and Nevis": "KN",
  "Saint Lucia": "LC",
  "Saint Vincent and the Grenadines": "VC",
  Samoa: "WS",
  "San Marino": "SM",
  "São Tomé and Príncipe": "ST",
  "Saudi Arabia": "SA",
  Senegal: "SN",
  Serbia: "RS",
  Seychelles: "SC",
  "Sierra Leone": "SL",
  Singapore: "SG",
  Slovakia: "SK",
  Slovenia: "SI",
  "Solomon Islands": "SB",
  Somalia: "SO",
  "South Africa": "ZA",

  // United Kingdom variants
  UK: "GB",
  "United Kingdom": "GB",
  Britain: "GB",

  Greece: "GR",
  "Hellenic Republic": "GR",

  Spain: "ES",
  "Sri Lanka": "LK",
  Sudan: "SD",
  Suriname: "SR",
  Sweden: "SE",
  Switzerland: "CH",
  Syria: "SY",
  Taiwan: "TW",
  Tajikistan: "TJ",
  Tanzania: "TZ",
  Thailand: "TH",
  Togo: "TG",
  Tokelau: "TK",
  Tonga: "TO",
  "Trinidad and Tobago": "TT",
  Tunisia: "TN",
  Turkey: "TR",
  Turkmenistan: "TM",
  Tuvalu: "TV",
  Uganda: "UG",
  Ukraine: "UA",
  UAE: "AE",
  Uruguay: "UY",
  Uzbekistan: "UZ",
  Vanuatu: "VU",
  "Vatican City": "VA",
  Venezuela: "VE",
  Vietnam: "VN",
  "Wallis and Futuna": "WF",
  "Western Sahara": "EH",
  Yemen: "YE",
  Zambia: "ZM",
  Zimbabwe: "ZW",

  // Extra territories & dependencies
  "Åland Islands": "AX",
  "American Samoa": "AS",
  "Bonaire, Sint Eustatius and Saba": "BQ",
  "Cook Islands": "CK",
  Curaçao: "CW",
  "Faroe Islands": "FO",
  "French Southern Territories": "TF",
  Gibraltar: "GI",
  Greenland: "GL",
  Guadeloupe: "GP",
  Guam: "GU",
  "Hong Kong": "HK",
  Macau: "MO",
  Martinique: "MQ",
  Montserrat: "MS",
  "New Caledonia": "NC",
  Niue: "NU",
  "Norfolk Island": "NF",
  "Northern Mariana Islands": "MP",
  "Puerto Rico": "PR",
  Réunion: "RE",
  "Saint Barthélemy": "BL",
  "Saint Helena, Ascension and Tristan da Cunha": "SH",
  "Saint Martin": "MF",
  "Saint Pierre and Miquelon": "PM",
  "Sint Maarten": "SX",
  "South Georgia and the South Sandwich Islands": "GS",
  "Svalbard and Jan Mayen": "SJ",
  Tokelau: "TK",
  "Turks and Caicos Islands": "TC",
  "U.S. Virgin Islands": "VI",
  "British Virgin Islands": "VG",
  Cambodia: "KH",
  Chile: "CL",
  "Costa Rica": "CR",
};

export default countryToFlagCode;
